<template>
  <q-checkbox
    v-model="currentValue"
    :color="color"
    :label="label"
    :size="size"
    :dense="dense"
    :disable="disable"
  />
</template>

<script>
/**
 * size: {string} 'xs', 'sm', 'md', 'lg', 'xl'
 */

export default {
  name: 'Checkbox',
  props: {
    color: { type: String, default: 'dark' },
    label: { type: String },
    value: {
      type: Boolean,
    },
    size: {
      type: String,
      default: 'md',
      validator: (size) =>
        ['xs', 'sm', 'md', 'lg', 'xl', 'small', 'medium', 'large'].includes(size),
    },
    disable: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    currentValue: {
      set(value) {
        this.$emit('input', value);
      },
      get() {
        return this.value;
      },
    },
  },
};
</script>

<style lang="scss" scoped></style>
